import { DrawerOverlay } from "@chakra-ui/react";
import React, { useState } from "react";
import { AppDrawer } from "../../AppDrawer";
import { AppDrawerContent } from "../../modals/AppDrawerContent";
import { AddDataSourceWorkflow } from "./workflows/AddDataSourceWorkflow";

export function AddDataSourceDrawer({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): React.ReactElement {
  const [allowQuickClose, setAllowQuickClose] = useState(true);

  return (
    <AppDrawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      size="sm"
      closeOnOverlayClick={allowQuickClose}
      closeOnEsc={allowQuickClose}
    >
      <DrawerOverlay />
      <AppDrawerContent>
        <AddDataSourceWorkflow
          onClose={onClose}
          onComplete={onClose}
          setAllowQuickClose={setAllowQuickClose}
        />
      </AppDrawerContent>
    </AppDrawer>
  );
}
